import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { DemoDevicesComponent } from '@app/modules/demo/pages/demo-devices/demo-devices.component';
import { UserLoadedGuard } from './guards/user-loaded.guard';
import { DemoCalendarComponent } from './pages/calendar/calendar.component';
import { DemoDashboardComponent } from './pages/dashboard/dashboard.component';
import { DemoDirectComponent } from './pages/direct/direct.component';
import { DemoGXComponent } from './pages/gx/gx.component';
import { DemoInboxComponent } from './pages/inbox/inbox.component';
import { DemoMetricsComponent } from './pages/metrics/metrics.component';
import { DemoOperationsComponent } from './pages/operations/operations.component';
import { DemoPropertiesComponent } from './pages/properties/properties.component';
import { DemoStatementsComponent } from '@app/modules/demo/pages/demo-statements/demo-statements.component';
import { DemoMyBusinessComponent } from './pages/demo-my-business/demo-my-business.component';

const routes: Routes = [
  {
    path: 'dashboard',
    component: DemoDashboardComponent,
    data: {
      title: 'Dashboard',
      identifier: 'dashboard',
    },
    canActivate: [UserLoadedGuard],
  },
  {
    path: 'inbox',
    component: DemoInboxComponent,
    data: {
      title: 'Inbox',
      identifier: 'inbox',
    },
  },
  {
    path: 'properties',
    component: DemoPropertiesComponent,
    data: {
      title: 'Properties',
      identifier: 'property',
    },
  },

  {
    path: 'calendar',
    component: DemoCalendarComponent,
    data: {
      title: 'Calendar',
      identifier: 'calendar',
    },
  },
  {
    path: 'gx',
    component: DemoGXComponent,
    data: {
      title: 'Guest Experience',
      identifier: 'gx-overview',
    },
  },
  {
    path: 'operations',
    component: DemoOperationsComponent,
    data: {
      title: 'Operations',
      identifier: 'ops-overview',
    },
  },
  {
    path: 'metrics',
    component: DemoMetricsComponent,
    data: {
      title: 'Metrics',
      identifier: 'metrics-overview',
    },
  },
  {
    path: 'direct',
    component: DemoDirectComponent,
    data: {
      title: 'Direct',
      identifier: 'direct-overview',
    },
  },
  {
    path: 'devices',
    component: DemoDevicesComponent,
    data: {
      title: 'Devices',
      identifier: 'devices-overview',
    },
  },
  {
    path: 'statements',
    component: DemoStatementsComponent,
    data: {
      title: 'Statements',
    },
  },
  {
    path: 'my-business',
    component: DemoMyBusinessComponent,
    data: {
      title: 'My Business',
    },
  },
  {
    path: '',
    redirectTo: 'dashboard',
    pathMatch: 'full',
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class DemoRoutingModule {}
